var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('video-product-detail',_vm._g({ref:"product",attrs:{"item":_vm.item,"actions-allowed":_vm.actionsAllowed,"offset":_vm.offset}},_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }